import styles from "./css/Button.module.css"

export default function Button({ text, href, color = "#33d1ad", onClick }) {
    
    return (
        <div className={styles.buttonWrap}>
            <a href={href} onClick={onClick} style={color ? {color: color, borderColor: color} : {}}>{text}</a>
        </div>
    )
}